import * as types from './mutation-types.js'

const mutations = {
  [types.CLEAR_EPISODE] (state) {
    state.episode = {}
  },
  [types.CLEAR_EPISODES] (state) {
    state.episodes = []
    state.episodeCount = '-'
  },
  [types.SET_EPISODE_COUNT] (state, episodeCount) {
    state.episodeCount = episodeCount
  },
  [types.SET_EPISODE_CREATION_KEYS] (state, keys) {
    state.episodeCreationKeys = keys
  },
  [types.SET_EPISODE_LIST] (state, episodes) {
    state.episodes = episodes
  },
  [types.SET_CURRENT_EPISODE] (state, episode) {
    state.episode = episode
  },
  [types.SET_LAST_EPISODE] (state, episode) {
    state.lastEpisode = episode
  },
  [types.SET_TOP_EPISODE] (state, episode) {
    state.topEpisode = episode
  }
}

export default mutations
